<template>
    <keep-alive>
        <div class="modal-mask">
            <div class="modal-wrapper gnbSrch-wrap">
                <div class="modal_size gnbSrch_size">
                    <a href="JavaScript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                    <a href="JavaScript:" class="ico_prev" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                    <dl class="modal_content">
                        <dt class="ellipsis">
                            <i>{{$t('FIELD.GLOBAL.SEARCH')}}</i>
                        </dt>
                        <dd>
                            <keep-alive>
                                <base-search-area
                                    :bToggle="true"
                                    :topClass="'gnbSrch_wrap'"
                                    :callSearchFunc="callSearchFunc"
                                />
                            </keep-alive>
                        </dd>
                    </dl>
                    <!-- //srchTop_wrap -->
                </div>
            </div>
        </div>
    </keep-alive>
</template>
<script>
import Vue          from 'vue';
import qs           from 'query-string';
import axios        from 'axios';
import { SDLUtil }  from '@/utils';
import { EventBus } from '@/utils/EventBus';
import SearchArea   from './SearchArea';

export default {
    name: 'searchEntryPopup',
    components: {
        'base-search-area'  : SearchArea
    },
    computed: {
    },
    props: {
        rtnSearchFunc: { type: Function }
    },
    data() {
        return {
            temp: '',
        };
    },
    methods: {
        callSearchFunc(param) {
            if (param.keyword.length < 3) {
                SDLUtil.alert('MESSAGE.SEARCH.INPUT.KWORD');
                return true;
            }
            if (param.screenMode == 'D') {
                let frDate = SDLUtil.convertDate(param.FR_DT).replace(/-/g, '');
                let toDate = SDLUtil.convertDate(param.TO_DT).replace(/-/g, '');
                if (Number(toDate) < Number(frDate)) {
                    SDLUtil.alert('MESSAGE.DATE.VALIDATION.START.END');
                    return true;
                }
            }
            this.$emit('close');
            this.rtnSearchFunc(param);
        }
    },
    watch: { // keyword를 clearable로 지웠을 때...
        // Change of date unit
    },
    mounted() {
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/intgSearch/SearchEntryPopup.vue